import { Model } from '@/clients/http'

import { OfferHttpParams, OfferResponses } from '@/types'

export class OfferModel extends Model {
  public static readonly correlations = {
    GET_LIST:  'GET_OFFER_LIST',
    GET_STATS: 'GET_OFFER_STATS',
    GET_BY_ID: 'GET_OFFER_BY_ID',
    CREATE:    'CREATE_OFFER',
    UPDATE:    'UPDATE_OFFER',
    DELETE:    'DELETE_OFFER',
    RESTORE:   'RESTORE_OFFER',
  }

  public static readonly endpoints = {
    getList: (p?: OfferHttpParams.GetList) =>
      this.createEndpoint({ url: '/api/backoffice/offer', params: p?.params, query: p?.query }),
    getStats: (p?: OfferHttpParams.GetStats) =>
      this.createEndpoint({ url: '/api/backoffice/offer/group', params: p?.params, query: p?.query }),
    getById: (p?: OfferHttpParams.GetById) =>
      this.createEndpoint({ url: '/api/backoffice/offer/:id', params: p?.params, query: p?.query }),
    create: (p?: OfferHttpParams.Create) =>
      this.createEndpoint({ url: '/api/backoffice/offer', params: p?.params }),
    update: (p?: OfferHttpParams.Update) =>
      this.createEndpoint({ url: '/api/backoffice/offer/:id', params: p?.params }),
    delete: (p?: OfferHttpParams.Delete) =>
      this.createEndpoint({ url: '/api/backoffice/offer/:id', params: p?.params }),
    restore: (p?: OfferHttpParams.Restore) =>
      this.createEndpoint({ url: '/api/backoffice/offer/:id/restore', params: p?.params }),
  }

  public static readonly getList = async (props?: OfferHttpParams.GetList) =>
    this.createHttpRequest<OfferResponses.GetList, OfferResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: { method: 'get', url: this.endpoints.getList(props), useBearerToken: true },
      store: props?.store,
    })

  public static readonly getStats = async (props?: OfferHttpParams.GetStats) =>
    this.createHttpRequest<OfferResponses.GetStats, OfferResponses.GetStatsError>({
      correlationKey: this.correlations.GET_STATS,
      payload: { method: 'get', url: this.endpoints.getStats(props), useBearerToken: true },
      store: props?.store,
    })

  public static readonly getById = async (props: OfferHttpParams.GetById) =>
    this.createHttpRequest<OfferResponses.GetById, OfferResponses.GetByIdError>({
      correlationKey: this.correlations.GET_BY_ID,
      payload: { method: 'get', url: this.endpoints.getById(props), useBearerToken: true },
      store: props?.store,
    })

  public static readonly create = async (props: OfferHttpParams.Create) =>
    this.createHttpRequest<OfferResponses.Create, OfferResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: { method: 'post', url: this.endpoints.create(props), body: props.body, useBearerToken: true },
      store: props?.store,
    })

  public static readonly update = async (props: OfferHttpParams.Update) =>
    this.createHttpRequest<OfferResponses.Update, OfferResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: { method: 'put', url: this.endpoints.update(props), body: props.body, useBearerToken: true },
      store: props?.store,
    })

  public static readonly delete = async (props: OfferHttpParams.Delete) =>
    this.createHttpRequest<OfferResponses.Delete, OfferResponses.DeleteError>({
      correlationKey: this.correlations.DELETE,
      payload: { method: 'delete', url: this.endpoints.delete(props), useBearerToken: true },
      store: props?.store,
    })

  public static readonly restore = async (props: OfferHttpParams.Restore) =>
    this.createHttpRequest<OfferResponses.Restore, OfferResponses.RestoreError>({
      correlationKey: this.correlations.RESTORE,
      payload: { method: 'post', url: this.endpoints.restore(props), useBearerToken: true },
      store: props?.store,
    })
}
